import { createReducer, on } from '@ngrx/store';
import { 
  fetchLanguages,
  fetchLanguagesSuccess,
  fetchLanguagesFailure } from './language.actions';
import { LanguageState } from '@models/index';

const initialState: LanguageState = {
  isLoaded: false,
  data: [],
  selectedItem: {},
  error: ''
};

const _languageReducer = createReducer(
  initialState ,

  on(fetchLanguages, (state, { filterOptions }) => {
    return state;
  }),
  on(fetchLanguagesSuccess, (state, { languages }) => {
    
    const payload = {
      isLoaded: true,
      data: languages,
      selectedItem: {}
    };

    return { ...state, ...payload };
  }),
  on(fetchLanguagesFailure, (state, { error }) => {
    const payload = {
      isLoaded: true,
      error
    };
    return { ...state, ...payload };
  }),
);

export function languageReducer(state, action) {
  return _languageReducer(state, action);
}
